import { useCallback, useEffect, useRef, useState } from "react"

import { useFilteredProps, useResponsive, useUtilities } from "@/modules/cms/views/post/components/builder/context"

import { getDeviceValues, parseByUtility, usePureCraftProp } from "../hooks"

import { useToolbar } from "./context"

export default function Filter({ trigger }) {
  const [open, setOpen] = useState(false)
  const { useChangeOpenPopover } = useToolbar()
  useChangeOpenPopover({ open, value: 'filterProps' })

  const { value: filteredProps, setValue: setFilteredProps } = useFilteredProps()
  const { value } = usePureCraftProp('properties')
  const { utilitiesParsed } = useUtilities()
  const { device } = useResponsive()
  const filteredPropsRef = useRef(filteredProps)

  const handleFilter = useCallback(() => {
    const valuesByUtility = parseByUtility(value, '.') || {}
    const currentUtility = valuesByUtility?.[utilitiesParsed || 'default'] || {}
    const currentDevice = getDeviceValues(currentUtility, device)

    if (!currentDevice) {
      setFilteredProps([])
      setOpen(true)
      return
    }

    setFilteredProps(getKeysWithValue(currentDevice))
    setOpen(true)
  }, [setFilteredProps, utilitiesParsed, value, device])

  const handleClickFilter = () => {
    if (filteredProps) {
      setOpen(false)
      setFilteredProps(undefined)
      return
    }

    handleFilter()
  }

  useEffect(() => {
    filteredPropsRef.current = filteredProps
  }, [filteredProps])

  useEffect(() => {
    if (filteredPropsRef.current) {
      handleFilter()
    }
  }, [utilitiesParsed, handleFilter])

  return <>
    <div onClick={handleClickFilter} className="w-full h-full flex justify-center items-center">
      {trigger}
    </div>
  </>
}

export function getKeysWithValue(obj = {}) {
  return Object.entries(obj).flatMap(([key, val]) => {
    if ([null, undefined, '', false].includes(val) || (Array.isArray(val) && val.length === 0)) {
      return []
    }

    if (CUSTOM_VALIDATION[key]) {
      const customKeys = CUSTOM_VALIDATION[key](val)
      return customKeys.length ? customKeys : []
    }

    if (typeof val === 'object' && !Array.isArray(val)) {
      const children = getKeysWithValue(val)

      if (PROPS_COMPOUND.includes(key) && children.length > 0) {
        return children.map(childKey => `${key}.${childKey}`)
      }

      return children.length ? [key] : []
    }
    return [key]
  })
}

const CUSTOM_VALIDATION = {
  attributes: value => {
    const keys = Object.keys(value).filter(key => !['className', 'class'].includes(key))
    return keys.map(key => `attributes.${key}`)
  },
}

const PROPS_COMPOUND = ['flex', 'grid']
